import { alpha } from '@mui/system';

export const focusCommentKeyframes = theme => {
  return [
    { boxShadow: `0 0 ${theme.spacing(1)} 0 ${alpha(theme.palette.primary.main, 1)}` },
    { boxShadow: `0 0 ${theme.spacing(1)} 0 ${alpha(theme.palette.primary.main, 1)}` },
    { boxShadow: `0 0 ${theme.spacing(1)} 0 ${alpha(theme.palette.primary.main, 1)}` },
    { boxShadow: `0 0 ${theme.spacing(1)} 0 ${alpha(theme.palette.primary.main, 1)}` },
    { boxShadow: `0 0 ${theme.spacing(1)} 0 ${alpha(theme.palette.primary.main, 1)}` },
    { boxShadow: `0 0 ${theme.spacing(1)} 0 ${alpha(theme.palette.primary.main, 1)}` },
    { boxShadow: `0 0 ${theme.spacing(1)} 0 ${alpha(theme.palette.primary.main, 0.75)}` },
    { boxShadow: `0 0 ${theme.spacing(1)} 0 ${alpha(theme.palette.primary.main, 0.5)}` },
    { boxShadow: `0 0 ${theme.spacing(1)} 0 ${alpha(theme.palette.primary.main, 0.25)}` },
    { boxShadow: `0 0 ${theme.spacing(1)} 0 ${alpha(theme.palette.primary.main, 0.25)}` }
  ];
};

export const focusCommentTiming = {
  duration: 2000,
  iterations: 1
};
